import { SearchParams } from '@prismamedia/one-components';
import { atom, useRecoilState } from 'recoil';
import { BrandKey } from '__generated__/queries-newsletter';

const brandKey = atom<BrandKey | undefined>({
  key: 'brandKey',
  default: undefined,
});
export const useGlobalBrandKey = () => useRecoilState(brandKey);

const newslettersFilter = atom<string[]>({
  key: 'newslettersFilter',
  default: [],
});
export const useGlobalNewslettersFilter = () =>
  useRecoilState(newslettersFilter);

const searchParams = atom<SearchParams>({
  key: 'searchParams',
  default: {},
});
export const useGlobalSearchParams = () => useRecoilState(searchParams);
